import React, { useEffect, useState } from 'react';
import ArchiveIcon from '@mui/icons-material/ArchiveOutlined';
import Button from '@mui/material/Button';
import { useNavigate } from 'react-router-dom';

import { useAuthenticatedState } from 'src/authenticated-state/context';
import { FlexColumn } from 'src/components/flex';
import { useConversationsPageContext } from 'src/pages/landlord/conversations/context';
import Category from 'src/pages/landlord/conversations/components/list/ConversationsListCategory';
import NoSearchResults from 'src/pages/landlord/conversations/components/list/ConversationsNoSearchResults';

export default function ConversationsList() {
    const {
        conversationsUpdatedAt,
    } = useAuthenticatedState();
    const {
        isSearchOrFilterActive,
        filteredConversations,
        categories,
        search: searchQuery,
        filter: searchFilter,
    } = useConversationsPageContext();
    const navigate = useNavigate();

    const isSearchingWithoutResults = isSearchOrFilterActive && filteredConversations !== undefined && filteredConversations.length === 0;

    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        if (isLoading) {
            setIsLoading(false);
        }
    }, [conversationsUpdatedAt, isLoading]);

    return (
        <FlexColumn gap={2} py={3} alignItems="center">
            {!isSearchingWithoutResults && categories.map((cat) => (
                <Category key={cat} category={cat} />
            ))}

            {isSearchingWithoutResults && (
                <NoSearchResults />
            )}

            {/* only show button if the user is searching */}
            {isSearchOrFilterActive && (
                <Button
                    role="link"
                    variant="contained"
                    onClick={() => {
                        const params = new URLSearchParams();
                        if (searchFilter) {
                            for (const [key, value] of Object.entries(searchFilter)) {
                                if (value && !(Array.isArray(value) && value.length === 0)) {
                                    params.append(key, String(value));
                                }
                            }
                        }
                        if (searchQuery) {
                            params.append('q', searchQuery || '');
                        }
                        const path = '/landlord/inner/archive?' + params.toString();

                        navigate(path);
                    }}
                    startIcon={<ArchiveIcon />}
                    data-testid="search-archived-btn"
                >
                    Search In Archive
                </Button>
            )}
        </FlexColumn >
    );
}
